import { render, staticRenderFns } from "./purchaseOrderList.vue?vue&type=template&id=6f5cbc8a&scoped=true"
import script from "./purchaseOrderList.vue?vue&type=script&lang=js"
export * from "./purchaseOrderList.vue?vue&type=script&lang=js"
import style0 from "./purchaseOrderList.vue?vue&type=style&index=0&id=6f5cbc8a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f5cbc8a",
  null
  
)

export default component.exports